import script from "./LoadingProcess.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingProcess.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingProcess.vue?vue&type=style&index=0&id=83f08d74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83f08d74"]])

export default __exports__